export default __webpack_public_path__ + "static/media/tiktok (1).b77b8dbc.svg";